export const RegisterResponse = {
  AlreadyExists: "email already exists",
  Reactivation: "account re-activation",
  Success: "success",
};
